
import { SelectProps } from "antd";
import { AccommodationProduct } from "./Accommodation";
import { CourseProduct } from "./Course";
import { AddOnsProduct } from "./AddOns";
import { TransfersProduct } from "./Transfers";
import { PackageProduct } from "./Package";

export interface ProductBase {
    id: number|string,
    name: string,
    lastModifiedDate?: Date|undefined,
    lastUpdatedBy?: string|undefined,
    division: number,
    divisionText?: string,
    entityUpdate:boolean,
    active: boolean,
    excludedBookingSystemIds?: (number | string)[],
    numberOfOneToOneLessonsPerWeek?: number
}

export interface ProductFilter {
    fieldName: (keyof ProductKey);
    fieldValue: any[],
    fieldSecondValue?: any
}

export type Product = undefined | AccommodationProduct | CourseProduct | AddOnsProduct | TransfersProduct | PackageProduct;

export type ProductKey = AccommodationProduct & CourseProduct & AddOnsProduct & TransfersProduct & PackageProduct;

export type FilterDataType = SelectProps;

export enum FilterValueType {
    primaryValue,
    secondaryValue
}